
import ProductsCarouselModal from './ProductsCarouselModal.vue';

export default {
  components: {
    ProductsCarouselModal,
  },
  props: {
    images: {
      type: Array,
      default: () => [],
      required: true,
    },
    videos: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      slideArr: [],
      showModal: false,
      currentSlide: 0,
    };
  },
  watch: {
    // jl: open carousel modal when user clicks on story image (overview section)
    '$store.state.carouselModal.targetImageSlug': function (targetImageSlug) {
      if (targetImageSlug && !this.showModal) {
        this.openModalToSlug(targetImageSlug);
      }
    },
  },
  async created() {
    const gallery = [...this.images];

    // an: insert at index 1 all Videos,
    gallery.splice(1, 0, ...this.videos);

    this.slideArr = gallery.map((item) => {
      const data = { ...item };

      if (data.embed_code) {
        data.embed_loaded = false;
      }

      return data;
    });

    this.thumbnails = this.slideArr.map((item) => ({
      image: this.getThumbnailImage(item),
      embedVideo: item.embed_code,
    }));
  },
  methods: {
    getThumbnailImage(item) {
      if (item.image) {
        return `${item.image}?width=150`;
      }

      if (item.thumbnail) {
        return `${item.thumbnail}?width=150`;
      }

      return item.embed_thumbnails?.sm || '';
    },
    openModalToSlug(targetImageSlug) {
      // jl: when user clicks html_body/story image in overview, let's find and set the currentSlide
      //     to the target image *before* we open the modal
      let slideIndex = this.slideArr.findIndex((slide) => (
        slide.image && slide.slug === targetImageSlug
      ));

      // jw: if we couldn't identify the image from the slug just default to the first one.
      if (slideIndex === -1) {
        slideIndex = 0;
      }

      this.openModal(slideIndex);
    },
    openModal(slideIndex = 0) {
      this.currentSlide = slideIndex;
      this.showModal = true;

      this.updateScrollToTop();
      this.updateModalScrollClass();
    },
    closeModal() {
      this.showModal = false;

      // jl: reset state only if modal was opened via story image click
      if (this.$store.state.carouselModal.targetImageSlug) {
        this.$store.dispatch('carouselModal/closeModal');
      }

      this.updateScrollToTop();
      this.updateModalScrollClass();
    },
    updateScrollToTop() {
      this.$store.dispatch(
        'scrollToTop/updateVisibility',
        { hideScrollToTop: this.showModal },
      );
    },
    updateModalScrollClass() {
      // Hide page scrollbars when modal is open
      if (document && this.showModal) {
        document.body.classList.add('carousel-hide-scroll');
      } else if (document) {
        document.body.classList.remove('carousel-hide-scroll');
      }
    },
  },
};
